import { defineComponent as L, getCurrentInstance as M, computed as S, reactive as C, toRefs as N, watch as R, provide as W, onBeforeUnmount as P } from "vue";
import { ElTooltip as V } from "./index577.js";
import { ElScrollbar as k } from "./index674.js";
import { ElTag as x } from "./index685.js";
import { ElIcon as G } from "./index538.js";
import { useProps as j } from "./index678.js";
import U from "./index682.js";
import B from "./index789.js";
import { useSelect as K } from "./index790.js";
import { selectKey as q } from "./index676.js";
import z from "./index791.js";
import { selectProps as F } from "./index677.js";
import I from "./index683.js";
import J from "./index598.js";
import { useCalcInputWidth as Q } from "./index700.js";
import { UPDATE_MODEL_EVENT as X, CHANGE_EVENT as Y } from "./index584.js";
import { isArray as Z, isObject as f } from "./index575.js";
import { flattedChildren as $ } from "./index654.js";
const _ = "ElSelect", d = /* @__PURE__ */ new WeakMap(), ee = (n) => (...o) => {
  var i, l;
  const p = o[0];
  if (!p || p.includes(
    'Slot "default" invoked outside of the render function'
  ) && ((i = o[2]) != null && i.includes("ElTreeSelect")))
    return;
  const s = (l = d.get(n)) == null ? void 0 : l.originalWarnHandler;
  if (s) {
    s(...o);
    return;
  }
  console.warn(...o);
}, te = (n) => {
  let o = d.get(n);
  return o || (o = {
    originalWarnHandler: n.config.warnHandler,
    handler: ee(n),
    count: 0
  }, d.set(n, o)), o;
};
var Se = L({
  name: _,
  componentName: _,
  components: {
    ElSelectMenu: B,
    ElOption: U,
    ElOptions: z,
    ElOptionGroup: I,
    ElTag: x,
    ElScrollbar: k,
    ElTooltip: V,
    ElIcon: G
  },
  directives: { ClickOutside: J },
  props: F,
  emits: [
    X,
    Y,
    "remove-tag",
    "clear",
    "visible-change",
    "focus",
    "blur",
    "popup-scroll"
  ],
  setup(n, { emit: o, slots: i }) {
    const l = M(), p = te(l.appContext);
    p.count += 1, l.appContext.config.warnHandler = p.handler;
    const s = S(() => {
      const { modelValue: e, multiple: a } = n, r = a ? [] : void 0;
      return Z(e) ? a ? e : r : a ? r : e;
    }), m = C({
      ...N(n),
      modelValue: s
    }), t = K(m, o), { calculatorRef: y, inputStyle: H } = Q(), { getLabel: E, getValue: v, getOptions: T, getDisabled: O } = j(n), w = (e) => ({
      label: E(e),
      value: v(e),
      disabled: O(e)
    }), g = (e) => e.reduce((a, r) => (a.push(r), r.children && r.children.length > 0 && a.push(...g(r.children)), a), []), D = (e) => {
      $(e || []).forEach((r) => {
        var h;
        if (f(r) && // @ts-expect-error
        (r.type.name === "ElOption" || r.type.name === "ElTree")) {
          const b = r.type.name;
          if (b === "ElTree") {
            const c = ((h = r.props) == null ? void 0 : h.data) || [];
            g(c).forEach((u) => {
              u.currentLabel = u.label || (f(u.value) ? "" : u.value), t.onOptionCreate(u);
            });
          } else if (b === "ElOption") {
            const c = { ...r.props };
            c.currentLabel = c.label || (f(c.value) ? "" : c.value), t.onOptionCreate(c);
          }
        }
      });
    };
    R(
      () => {
        var e;
        return [(e = i.default) == null ? void 0 : e.call(i), s.value];
      },
      () => {
        var e;
        n.persistent || t.expanded.value || (t.states.options.clear(), D((e = i.default) == null ? void 0 : e.call(i)));
      },
      {
        immediate: !0
      }
    ), W(
      q,
      C({
        props: m,
        states: t.states,
        selectRef: t.selectRef,
        optionsArray: t.optionsArray,
        setSelected: t.setSelected,
        handleOptionSelect: t.handleOptionSelect,
        onOptionCreate: t.onOptionCreate,
        onOptionDestroy: t.onOptionDestroy
      })
    );
    const A = S(() => n.multiple ? t.states.selected.map((e) => e.currentLabel) : t.states.selectedLabel);
    return P(() => {
      const e = d.get(l.appContext);
      e && (e.count -= 1, e.count <= 0 && (l.appContext.config.warnHandler = e.originalWarnHandler, d.delete(l.appContext)));
    }), {
      ...t,
      modelValue: s,
      selectedLabel: A,
      calculatorRef: y,
      inputStyle: H,
      getLabel: E,
      getValue: v,
      getOptions: T,
      getDisabled: O,
      getOptionProps: w
    };
  }
});
export {
  Se as default
};
